import PropTypes from "prop-types";
import React, { useEffect, useRef, useState } from "react";
import CompoundIcon from "assets/images/bx-home-circle.svg";
import SimpleBar from "simplebar-react";
import DealsSvg from "assets/images/deals.svg";
import LeadsSvg from "assets/images/leads.svg";
import AppoinmentsSvg from "assets/images/appoinments.svg";
import MetisMenu from "metismenujs";
import { Link, withRouter } from "react-router-dom";
import { withTranslation } from "react-i18next";
import { adminPrefix } from "configs/routePrefix";
import DynamicAssignServices from "services/Admin/DynamicAssignServices";
import { SuccessOk } from "configs/statusCode";
import { useSelector, useDispatch } from "react-redux";
import { authenticate } from "store/Auth/actions";
import { Row, Spinner } from "reactstrap";
import { appendFilters } from "store/adminFilter/actions";
import { toast } from "react-toastify";

const AdminSidebarContent = (props) => {
	const ref = useRef();
	const dynamicAssignServices = new DynamicAssignServices();
	const AuthData = useSelector((state) => state.Auth);
	const dispatch = useDispatch();
	const [loading, setLoading] = useState(false);
	const [show, setShow] = useState(false);
	const isExist = (data) =>
		AuthData.permissions.includes(data) ||
		AuthData?.email === "admin@meras.com";

	useEffect(() => {
		(props.location.pathname.split("/")[2] === "payment-plan" ||
			props.location.pathname.split("/")[2] === "interactive") &&
			setShow(true);
	}, [props.location.pathname]);

	useEffect(() => {
		const pathName = props.location.pathname;
		const initMenu = () => {
			new MetisMenu("#side-menu");
			let matchingMenuItem = null;
			const ul = document.getElementById("side-menu");
			const items = ul.getElementsByTagName("a");
			for (let i = 0; i < items.length; ++i) {
				if (pathName.split("/")[2] === "setting") {
					if (pathName?.split("/")[3] === items[i].pathname?.split("/")[3]) {
						matchingMenuItem = items[i];
						break;
					}
				} else if (
					pathName?.split("/")[2] === items[i].pathname?.split("/")[2]
				) {
					matchingMenuItem = items[i];
					break;
				} else if (pathName === items[i].pathname) {
					matchingMenuItem = items[i];
					break;
				}
			}
			if (matchingMenuItem) {
				activateParentDropdown(matchingMenuItem);
			}
		};
		initMenu();
	}, [props.location.pathname]);

	useEffect(() => {
		ref.current.recalculate();
	});

	function scrollElement(item) {
		if (item) {
			const currentPosition = item.offsetTop;
			if (currentPosition > window.innerHeight) {
				ref.current.getScrollElement().scrollTop = currentPosition - 300;
			}
		}
	}

	function activateParentDropdown(item) {
		item.classList.add("active");
		const parent = item.parentElement;
		const parent2El = parent.childNodes[1];
		if (parent2El && parent2El.id !== "side-menu") {
			parent2El.classList.add("mm-show");
		}

		if (parent) {
			parent.classList.add("mm-active");
			const parent2 = parent.parentElement;
			if (parent2) {
				parent2.classList.add("mm-show"); // ul tag
				const parent3 = parent2.parentElement; // li tag
				if (parent3) {
					parent3.classList.add("mm-active"); // li
					parent3.childNodes[0].classList.add("mm-active"); //a
					const parent4 = parent3.parentElement; // ul
					if (parent4) {
						parent4.classList.add("mm-show"); // ul
						const parent5 = parent4.parentElement;
						if (parent5) {
							parent5.classList.add("mm-show"); // li
							parent5.childNodes[0].classList.add("mm-active"); // a tag
						}
					}
				}
			}
			scrollElement(item);
			return false;
		}
		scrollElement(item);
		return false;
	}

	useEffect(() => {
		if (AuthData.getSetting)
			dynamicAssignServices.getAssignStatus().then((res) => {
				if (res && res.status === SuccessOk) {
					dispatch(
						authenticate({
							system: parseInt(res.data.dynamic_assign) ? "Dynamic" : "Manual",
							systemId: res.data.id,
							getSetting: false,
						})
					);
				}
			});
	}, []);

	const changeSystemHandler = () => {
		setLoading(true);
		const data = { dynamic_assign: AuthData.system === "Dynamic" ? 0 : 1 };
		dynamicAssignServices.update(AuthData.systemId, data).then((res) => {
			if (res && res.status === SuccessOk) {
				dispatch(
					authenticate({
						system: AuthData.system === "Dynamic" ? "Manual" : "Dynamic",
					})
				);
				setLoading(false);
				toast.success("CRM status has been successfully updated");
			} else {
				setLoading(false);
			}
		});
	};

	return (
		<React.Fragment>
			<SimpleBar style={{ maxHeight: "100%" }} ref={ref}>
				<div id="sidebar-menu">
					<ul className="metismenu list-unstyled" id="side-menu">
						<li className="menu-title">Menu </li>
						<li>
							{isExist("dashboard.view") ? (
								<Link to={`${adminPrefix}/dashboard`}>
									<i className="fa fa-home"></i>
									<span>Dashboard</span>
								</Link>
							) : null}
						</li>
						<li>
							<Link to={`${adminPrefix}/campaign`}>
								<img src={LeadsSvg} style={{ marginRight: "12px" }} />
								<span>Campaign</span>
							</Link>
						</li>
						<li className={`position-relative d-flex`}>
							{isExist("developers.view") ? (
								<>
									<Link
										to={`${adminPrefix}/Admin-developer`}
										style={{ width: "85%" }}>
										<i className="fa fa-users-cog"></i>
										<span>Manage Developers</span>
									</Link>
									<button
										onClick={() => setShow((prev) => !prev)}
										style={{
											right: "16px",
											width: "15%",
											background: "none",
											color: `${show ? "#dedede" : "#a6b0cf"}`,
											border: "none",
										}}>
										{show ? (
											<i className="fa fa-angle-up"></i>
										) : (
											<i className="fa fa-angle-down"></i>
										)}
									</button>
								</>
							) : null}
						</li>
						<ul
							className={`sub-menu ps-3`}
							style={{ display: show ? "block" : "none" }}>
							<li>
								{isExist("payment.view") ? (
									<Link
										className="font-size-12"
										onClick={() => {
											localStorage.setItem("compound_id", null);
											dispatch(appendFilters({ path: "fromMaster" }));
										}}
										to={`${adminPrefix}/payment-plan`}>
										<i className="fas fa-money-check-alt"></i>
										<span>Manage Payment Plan</span>
									</Link>
								) : null}
							</li>
							<li className="mb-2">
								{isExist("interactive.view") ? (
									<Link
										className="font-size-12"
										to={`${adminPrefix}/interactive`}>
										<i className="far fa-hand-pointer fa-sm"></i>
										<span>Manage Interactive Mode</span>
									</Link>
								) : null}
							</li>
						</ul>
						<li>
							{isExist("admins.view") ? (
								<Link to={`${adminPrefix}/Admins`}>
									<i className="fa fa-users"></i>
									<span>Manage Admins</span>
								</Link>
							) : null}
						</li>
						<li>
							{isExist("salesRep.view") ? (
								<Link to={`${adminPrefix}/sales-rep`}>
									<i className="fas fa-user-minus"></i>
									<span>Manage Sales Rep</span>
								</Link>
							) : null}
						</li>
						<li>
							{isExist("seller.view") ? (
								<Link to={`${adminPrefix}/seller`}>
									<i className="fas fa-users"></i>
									<span>Manage Seller</span>
								</Link>
							) : null}
						</li>
						<li>
							{isExist("seller.view") ? (
								<Link to={`${adminPrefix}/manage-clients`}>
									<i className="fas fa-users"></i>
									<span>Manage Clients</span>
								</Link>
							) : null}
						</li>
						<li>
							{isExist("developers.view") ? (
								<Link to={`${adminPrefix}/sales-developer`}>
									<i className="fa fa-users-cog"></i>
									<span>Manage Sales Developers</span>
								</Link>
							) : null}
						</li>
						{/* <li>
              {isExist('rate.view') ? <Link to={`${adminPrefix}/rates`}>
                <i className="fas fa-percent"></i>
                <span>Manage Rates</span>
              </Link> : null}
            </li>
            <li>
              {isExist('compound.view') ? <Link to={`${adminPrefix}/compound-list`}>
                <img src={CompoundIcon} style={{ marginRight: "12px" }} />
                <span>Manage Compound</span>
              </Link> : null}
            </li> 
            <li>
              {isExist('compound.view') ? <Link to={`${adminPrefix}/building`}>
                <i className="fas fa-building"></i>
                <span>Manage Building</span>
              </Link> : null}
            </li>
            <li>
              {isExist('compound.view') ? <Link to={`${adminPrefix}/Admin-developer/property`}>
                <i className="fas fa-house-user"></i>
                <span>Manage Property</span>
              </Link> : null}
            </li> */}
						<li>
							{isExist("resale.view") ? (
								<Link to={`${adminPrefix}/resale`}>
									<i className="fas fa-exchange-alt"></i>
									<span>Manage Resales</span>
								</Link>
							) : null}
						</li>

						<li>
							{isExist("lead.view") ? (
								<Link to={`${adminPrefix}/leads`}>
									<img src={LeadsSvg} style={{ marginRight: "12px" }} />
									<span>Manage Leads</span>
								</Link>
							) : null}
						</li>
						<li>
							{isExist("deal.view") ? (
								<Link to={`${adminPrefix}/deals`}>
									<img src={DealsSvg} style={{ marginRight: "12px" }} />
									<span>Manage Deals</span>
								</Link>
							) : null}
						</li>
						<li>
							{isExist("appointment.view") ? (
								<Link to={`${adminPrefix}/appoinments`}>
									<img src={AppoinmentsSvg} style={{ marginRight: "12px" }} />
									<span>Manage Appointments</span>
								</Link>
							) : null}
						</li>

						<li>
							<Link to="/#" className="has-arrow waves-effect">
								<i className="fa fa-cog"></i>
								<span>Setting</span>
							</Link>
							<ul className="sub-menu" aria-expanded="false">
								{isExist("crm.edit") ? (
									<li>
										<Row className=" mx-4">
											{loading ? (
												<div className=" mx-2 w-100 d-flex justify-content-center">
													<Spinner color="primary" />
												</div>
											) : (
												<button
													className="btn btn-success"
													onClick={changeSystemHandler}>
													{AuthData.system === "Dynamic" ? "Manual" : "Dynamic"}
												</button>
											)}
										</Row>
									</li>
								) : null}
								{isExist("role.view") ? (
									<li>
										<Link to={`${adminPrefix}/setting/roles`}>
											Manage Users Roles
										</Link>
									</li>
								) : null}
								{isExist("setting.view") ? (
									<li>
										<Link to="/#" className="has-arrow waves-effect">
											<span>System Settings</span>
										</Link>
										<ul className="sub-menu" aria-expanded="false">
											<li>
												<Link to={`${adminPrefix}/setting/countries`}>
													Countries
												</Link>
											</li>
											<li>
												<Link to={`${adminPrefix}/setting/cities`}>Cities</Link>
											</li>
											<li>
												<Link to={`${adminPrefix}/setting/areas`}>
													Locations
												</Link>
											</li>
											<li>
												<Link to={`${adminPrefix}/setting/unit-types`}>
													Unit Types
												</Link>
											</li>
											<li>
												<Link to={`${adminPrefix}/setting/unit-sizes`}>
													Additional Areas
												</Link>
											</li>
											<li>
												<Link to={`${adminPrefix}/setting/categories`}>
													Categories
												</Link>
											</li>
											<li>
												<Link to={`${adminPrefix}/setting/finishing-types`}>
													Finishing Types
												</Link>
											</li>
											<li>
												<Link to={`${adminPrefix}/setting/facilities`}>
													Facilities
												</Link>
											</li>
											<li>
												<Link to={`${adminPrefix}/setting/facing`}>Facing</Link>
											</li>
											<li>
												<Link to={`${adminPrefix}/setting/amenities`}>
													Amenities
												</Link>
											</li>
											<li>
												<Link to={`${adminPrefix}/setting/criteria`}>
													Rating Criterias
												</Link>
											</li>
											<li>
												<Link to={`${adminPrefix}/setting/inventory`}>
													Manage Inventory
												</Link>
											</li>
										</ul>
									</li>
								) : null}
							</ul>
						</li>
					</ul>
				</div>
			</SimpleBar>
		</React.Fragment>
	);
};

AdminSidebarContent.propTypes = {
	location: PropTypes.object,
	t: PropTypes.any,
};

export default withRouter(withTranslation()(AdminSidebarContent));
